export default {"src":"/_next/static/media/sun-01.dc37b929.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};